import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";

import { RESOURCE_TOKEN_REGEX } from "../../domain/formula-grammar";

/**
 * This extension highlights resource tokens in the editor.
 * TODO: expand highlighting for different types of resources!
 */
export const ResourceTokenHighlight = Extension.create({
	name: "resource-token-highlight",

	// plugin that scans each text node in document via doc.descendants
	// adds Decoration.inline entries for matches via resource-token class
	addProseMirrorPlugins() {
		return [
			new Plugin({
				key: new PluginKey("resource-token-highlight"),
				props: {
					decorations: ({ doc }) => {
						const decorations: Decoration[] = [];

						doc.descendants((node, pos) => {
							if (!node.isText || !node.text) return;

							let match;
							while ((match = RESOURCE_TOKEN_REGEX.exec(node.text))) {
								const start = pos + match.index;
								const end = start + match[0].length;

								decorations.push(
									Decoration.inline(start, end, { class: "resource-token" })
								);
							}
						});

						return DecorationSet.create(doc, decorations);
					},
				},
			}),
		];
	},
});
